import React, { useEffect, useState ,useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getSideBarfilesActions,
  setTheDashboardactions,
  setTheDashboardonboadOverviewactions, ///---for the Onboard-overview---call
  setClientBranchActions,
  getSingleEmployeeActions,
  getEmployeeBranchName,
  SetDashboards,
  SettheCompletedOptions,
  SettheAllOptions,
  SettheDeclineOptions,
  setDropDownRenders,
  SetthePendingOptions,
  SettheApproveOptions,
  SetTheDashboardonBoardOverViewClientList,
  setZoneActions,
  setRegionActions,
  setGeoLoactionStateAction,
  setClientBranchSearchAction,
  setTheEmployeeeStateName,
  setTheEmployeeregionName,
  setTheEmployeeZoneName,
  setTheAttendanceregionObject,
  setTheAttendanceStateObject,
  setTheAttendanceZoneObject,
  setTheOnboardFromDateLIST,
  setOnboardTODtaeDASH,
  setTheApproveRequeststate,
  resetOrganizationFilterlist,
  SetTheDashboardonBoardOverViewOrganizationListed_stateList
} from "../../../Redux/Slice";
import { NavLink } from "react-router-dom";
import "../../../StyleSheet/MainComponent/DashBoard/DashBoard.scss";
///----Charts---
import { Doughnut } from "react-chartjs-2";
import { DateRangePicker, Stack } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Calender from "./Calender";
import { Chart } from "react-google-charts";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApproveIcon from "../../../Assets/MainComponent/DashboardIcons/UDS MEDIA ASSETS-30.svg";
import DeclineIcon from "../../../Assets/MainComponent/DashboardIcons/UDS MEDIA ASSETS-31.svg";

import PendignIcons from "../../../Assets/MainComponent/DashboardIcons/UDS MEDIA ASSETS-32.svg";

import EmployeeIcons from "../../../Assets/MainComponent/DashboardIcons/UDS MEDIA ASSETS-33.svg";
import { saveAs } from "file-saver";
import * as XLSX from "sheetjs-style";
import useDebouncedEffect from 'use-debounced-effect';

import { differenceInDays } from "date-fns";
import dayjs from "dayjs";

const OnboardingDash = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const dateRangeRef = useRef(null);
  
  const state = useSelector((state) => state);
  const UserData = useSelector((state) => state.SideBarFiles.Role);
  //  console.log(UserData ,"userData");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [nameList4, setOptions4] = useState([]);
  const [selectedValues, SetSelectValue] = useState([]);
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  let Ids = [];
  const [Client, setClients] = useState(state.DashboardOnboardOverviewCall.DashboardOnboardOverviewCLientList.value);
  const [clientname, setClientName] = useState();
  const [count, setCount] = useState(0);
  const [employeVerify, setempVer] = useState(0);
  const [declineemp, setDeclineEmp] = useState(0);
  const [PendingEmp, setPendignEmp] = useState(0);
  const [KYCPending, setkycpending] = useState(0);
  const [search, setSearch] = useState("");
  const RoleBased = useSelector((state) => state.SideBarFiles.Role);
  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };

  const UserObjectData = useSelector((state) => state.users.UserData);

  // const [selectedDates, setSelectedDates] = useState();
  const startDate = new Date();
  const endDate = new Date();

  const [selectedDates, setSelectedDates] = useState([startDate, endDate]);
  const [datestae, setdatest] = useState(false);

  // useEffect(()=>{
  //   dispatch(SetTheDashboardonBoardOverViewClientList({ value: "", label: "ALL" }));

  // },[])
  ///--filter----------------
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [REgion, setRegion] = useState([]);
  const [multiselect1, setMuliselect1] = useState([
    // { value: "", label: "All" },
    // state.ClientBranchIDs.RegionName,
    // state.ClientBranchIDs.EmployeeRegion
    state.ClientBranchIDs.Attendance_Region,
  ]);
  const [multiselect3, setMuliselect3] = useState([
    // { value: "", label: "All" },
    // state.ClientBranchIDs.ZoneName,
    // state.ClientBranchIDs.EmployeeZone
    state.ClientBranchIDs.Attendacen_Zone,
  ]);
  const [nameList5, setOptions5] = useState([]);
  const [Zone, setZone] = useState([]);
  const [datas, setData] = useState({
    // zone: state.ClientBranchIDs.ZoneName.value,
    // state: state.ClientBranchIDs.StateName.value,
    // region: state.ClientBranchIDs.RegionName.value,

    zone: state.ClientBranchIDs.Attendacen_Zone.value,
    state: state.ClientBranchIDs.Attendance_State.value,
    region: state.ClientBranchIDs.Attendance_Region.value,
  });
  const [multiselect, setMuliselect] = useState([
    //  { value: "", label: "All" }
    // state.ClientBranchIDs.StateName,
    // state.ClientBranchIDs.EmployeeListState
    state.ClientBranchIDs.Attendance_State,
  ]);

  ///-------for the -----counts based
  const [pendingCounts, setPendingCounts] = useState(0);
  const [DeclineCounts, setDeclineCount] = useState(0);
  const [EployeeVerifiy, setEmpVerifyed] = useState(0);

  ///----to find the ---zero
  const [payrolStatus, setPayrolstatus] = useState(false);
  const [RmStatus, setRMStatus] = useState(false);
  const [FindZero, setFindZero] = useState(false);

  ///----Filter-----------------------

  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
            organization_search:""

  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
    Clientsearch:"",
            organization_search:""

  };

  const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);

  const [Perecentagedata, setPercentageData] = useState({
    EmployeeCounts: 4,

    VerifiedEmpCount: 2,
    DeclineEmpCount: 4,
    PendingEmployeCount: 2,

    VerifiedEmp: 2,
    DeclineEmp: 4,
    PendingEmploye: 2,

    ///---for----payroll
    VerifiedPayEmp: 2,
    DeclinePayEmp: 4,
    PendingPayEmploye: 2,

    PayRequestCount: 2,
    ///---for----RM
    VerifiedRMEmp: 2,
    DeclineRMEmp: 4,
    PendingRMEmploye: 2,
    RMRequestCount: 2,
  });

  const [CountsofemployeeOnboard, setcountOfemployeeOnboard] = useState({
    EmployeeCounts: 4,

    VerifiedEmpCount: 2,
    DeclineEmpCount: 4,
    PendingEmployeCount: 2,

    VerifiedEmp: 2,
    DeclineEmp: 4,
    PendingEmploye: 2,

    ///---for----payroll
    VerifiedPayEmp: 2,
    DeclinePayEmp: 4,
    PendingPayEmploye: 2,

    PayRequestCount: 2,
    ///---for----RM
    VerifiedRMEmp: 2,
    DeclineRMEmp: 4,
    PendingRMEmploye: 2,
    RMRequestCount: 2,
  });
  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(today);
  var gt = convert(today);

  // console.log(it, gt);
  // state.EmployeeVerificationsNeed.FROMDATE,
  // state.EmployeeVerificationsNeed.TODATE,

  var st = convert(state.EmployeeVerificationsNeed.ONboardFROMDATE);
  var et = convert(state.EmployeeVerificationsNeed.ONboardTODATE);
  const today_day = dayjs().format("YYYY-MM-DD");

  const [range, setrange] = useState(
    state.EmployeeVerificationsNeed.ONboardFROMDATE == "" ? 
    
    // [it, gt] 
    [today_day,today_day]
    
    : [st, et]
  );
  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  ///--Rm percentages------------------

  const [Rmpending, setRmpending] = useState(0);
  const [Rmdecline, setRmDecline] = useState(0);
  const [RmApprove, setRmApprove] = useState(0);
  //// payrol---percentages

  const [payrolpen, setpaypend] = useState(0);
  const [payroldecline, setpaydecline] = useState(0);
  const [payrollVerifrf, setpayrolverfi] = useState(0);

  const getCurrentMonthStartAndEndDate = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();

    // Set the start date of the current month to the 1st day of the current month
    const firstDateOfMonth = new Date(currentYear, currentMonth, 1);

    // Set the end date of the current month to the last day of the current month
    const lastDateOfMonth = new Date(currentYear, currentMonth + 1, 0);

    const startDatemon = `${currentYear}-${String(currentMonth + 1).padStart(
      2,
      "0"
    )}-${String(currentDate.getDate()).padStart(2, "0")}`;

    // const endDatemon = `${currentYear}-${String(currentMonth + 1).padStart(
    //   2,
    //   "0"
    // )}-${String(lastDateOfMonth.getDate()).padStart(2, "0")}`;
    const endDatemon = `${currentYear}-${String(currentMonth + 1).padStart(
      2,
      "0"
    )}-${String(currentDate.getDate()).padStart(2, "0")}`;
    return {
      startDatemon,
      endDatemon,
    };
  };

  var { startDatemon, endDatemon } = getCurrentMonthStartAndEndDate();

  // const [datestae, setdatest] = useState(false);

  const [datefilter, setdatefilter] = useState({
    from_date: startDatemon,
    to_date: endDatemon,
    range: true,
  });


  const [Filterids , setfilterids] = useState({
  organization:state.DashboardOnboardOverviewCall.onboardashboardOnboardOverViewOrganizationList?.value,

})
  const [Organization_Val , setOrganization_Val] = useState(state.DashboardOnboardOverviewCall.onboardashboardOnboardOverViewOrganizationList);
  const [Organization_options , setOrganizations_options] = useState([]) 


        ///--------------Organizations-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.organization_search,
      page_size: 20,
      page: 1,
    };
    dispatch(resetOrganizationFilterlist(payloads));
  }, [SearchedVal.organization_search]);

  useEffect(()=>{
    if(state.organization_filterlist_tocall.Organization_filterlist_records){
      let ObjectArrayFormager = [];
      ObjectArrayFormager.push({
        value:"",label:"ALL"
      })
      state.organization_filterlist_tocall.Organization_filterlist_records.forEach((element) => {
        ObjectArrayFormager.push({
          value: element.id,
          label: element.organization_name,
        });
      });
      setOrganizations_options(ObjectArrayFormager);

    }
  },[state.organization_filterlist_tocall.Organization_filterlist_records ,SearchedVal.organization_search])





  // useEffect(() => {
  //   const payload = {
  //     count: 1,
  //   };

  //   dispatch(setTheDashboardactions(payload));
  // }, []);

  // useEffect(() => {
  //   if (state.users.UserData.data != undefined) {
  //   }
  //   if (UserObjectData.session) {
  //     const udsroleSelectedstate = [];
  //     const zoneselact = [];
  //     const regionsSelect = [];

  //     if (UserObjectData.data.state_id.length > 0) {
  //       UserObjectData.data.state_id.map((item, index) => {
  //         console.log(item, "287398273");
  //         if (index == 0) {
  //           udsroleSelectedstate.push({
  //             value: item.id,
  //             label: item.state_name,
  //           });
  //         }
  //       });

  //     }

  //      if (UserObjectData.data.state_id.length == 0) {
  //       udsroleSelectedstate.push({ value: "", label: "All" });
  //     }

  //     if (UserObjectData.data.zone_id.length > 0) {
  //       UserObjectData.data.zone_id.map((item, index) => {
  //         if (index == 0) {
  //           zoneselact.push({
  //             value: item.id,
  //             label: item.zone_name,
  //           });
  //         }
  //       });
  //     }

  //     if (UserObjectData.data.region_id.length > 0) {
  //       UserObjectData.data.region_id.map((item, index) => {
  //         if (index == 0) {
  //           regionsSelect.push({
  //             value: item.id,
  //             label: item.region_name,
  //           });
  //         }
  //       });

  //     }  if (UserObjectData.data.zone_id.length == 0) {
  //       zoneselact.push({ value: "", label: "All" });
  //     }  if (UserObjectData.data.region_id.length == 0) {
  //       regionsSelect.push({ value: "", label: "All" });
  //     }

  //     setData({
  //       ...datas,
  //       state: udsroleSelectedstate[0].value,
  //       zone: zoneselact[0].value,
  //       region: regionsSelect[0].value,
  //     });

  //     setMuliselect1(regionsSelect);
  //     setMuliselect(udsroleSelectedstate);

  //     setMuliselect3(zoneselact);

  //   }
  // }, [UserObjectData]);

  useEffect(() => {
    // if (
    //   Client != undefined ||
    //   datas.state == "" ||
    //   datas.region == "" ||
    //   datas.zone == ""
    // ) {
    setempVer(0);
    setCount(0);
    setPendignEmp(0);
    setDeclineEmp(0);
    setkycpending(0);

    ///---Rm

    setRmpending(0);
    setRmApprove(0);

    setRmDecline(0);

    setRmApprove(0);

    //// payroll
    setpaypend(0);

    setpaydecline(0);

    setpayrolverfi(0);
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
    const payload = {
      client: Client,
      state: datas.state,
      region: datas.region,
      zone: datas.zone,
      // from_date: datefilter.from_date,
      // to_date: datefilter.to_date,
      from_date: range[0],

      to_date: range[1],
      range: datefilter.range,
      organization:Filterids?.organization

    };
    setTimeout(() => {
  
      // dispatch(setTheDashboardactions(payload));
       dispatch(setTheDashboardonboadOverviewactions(payload))
    }, 250);
    

  }
    // }

    // else {
    //   const payload = {
    //     count: 1,
    //   };
    //   dispatch(setTheDashboardactions(payload));
    // }
  }, [Client, datas, datefilter, range ,Filterids]);
    // console.log(state.DashboardOnboardOverviewCall.onboardingOverviewdata , "DashboardOnboardOverviewCall");
useEffect(()=>{
  dispatch(setTheApproveRequeststate(7))

},[])
  ////-- dispatch --- the ----- client list
  // useEffect(() => {
  //   dispatch(SetTheDashboardonBoardOverViewClientList({ value: "", label: "All" }));
  //   // dispatch(setTheEmployeeeStateName(state.ClientBranchIDs.StateName));// just the initail values
  //   // dispatch(setTheEmployeeregionName(state.ClientBranchIDs.RegionName));
  //   // dispatch(setTheEmployeeZoneName(state.ClientBranchIDs.ZoneName))
  // }, [state.ClientBranchIDs.StateName]);
  // console.log(state.ClientBranchIDs.StateName , "2312");
  const formattedDates =
    selectedDates != null &&
    selectedDates.map((date) => {
      const isoString = date.toISOString();
      return isoString.substring(0, 10);
    });

  ////--max---current date to 60 dates , min --->previouse 15 date

  ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);

  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: 1,
      counts: 1,
      region_id: datas.region,
    };
    dispatch(setZoneActions(payloads));
    setZone(state.ZonePart.Zone);
  }, [datas.region, SearchedVal.zoneSearch]);

  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: 1,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: datas.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Count);
    setRegion(state.regioncall.RegionDat);
  }, [datas.state, SearchedVal.regionSearch]);

  useEffect(() => {
    const Datas = [];

    if (state.GeoState.State != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });

      state.GeoState.State.forEach((element) => {
        objectArray.push({ value: element.id, label: element.state_name.toUpperCase() });
      });

      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);

  ///  ///----------------------REgion-----------
  useEffect(() => {
    const Datas = [];

    setRegion(state.regioncall.RegionDat);
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });

      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({ value: element.id, label: element.region_name.toUpperCase() });
      });

      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);

  ///-------------Zone--------------
  useEffect(() => {
    const Datas = [];

    setZone(state.ZonePart.Zone);
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });

      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({ value: element.id, label: element.zone_name.toUpperCase() });
      });
      setOptions5(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);

  useEffect(() => {
    if (datestae) {
      setdatefilter({
        ...datefilter,
        from_date: formattedDates[0],
        to_date: formattedDates[1],
        range: true,
      });
    }
  }, [selectedDates]);

  useEffect(() => {
    if (state.DashboardOnboardOverviewCall.onboardingOverviewdataCLientList != null) {
      setClients(state.DashboardOnboardOverviewCall.onboardingOverviewdataCLientList.value);
      setClientName(state.DashboardOnboardOverviewCall.onboardingOverviewdataCLientList.label);
      console.log(Client, "clientsf");
    }
  }, [state.DashboardOnboardOverviewCall.onboardingOverviewdataCLientList]);

  useEffect(() => {
    const intervalId1 = setInterval(() => {
      if (state.DashboardOnboardOverviewCall.onboardingOverviewdata.employee_count != 0) {
        setCount((prevCount) => {
          if (prevCount < state.DashboardOnboardOverviewCall.onboardingOverviewdata.employee_count) {
            return prevCount + 1;
          } else {
            clearInterval(intervalId1);
            return prevCount;
          }
        });
      }
    }, 100);
    return () => clearInterval(intervalId1);
  }, [state.DashboardOnboardOverviewCall.onboardingOverviewdata.employee_count]);

  // useEffect(() => {
  //   const interval3 = setInterval(() => {
  //     if (state.DashboardOnboardOverviewCall.onboardingOverviewdata.decline_employee_percentage != 0) {
  //       setDeclineEmp((prevCount) => {
  //         if (
  //           prevCount <
  //           state.DashboardOnboardOverviewCall.onboardingOverviewdata.decline_employee_percentage
  //         ) {
  //           return prevCount + 1;
  //         } else {
  //           clearInterval(interval3);
  //           return prevCount;
  //         }
  //       });
  //     }
  //   }, 100);
  //   return () => clearInterval(interval3);
  // }, [state.DashboardOnboardOverviewCall.onboardingOverviewdata.decline_employee_percentage]);

  // useEffect(() => {
  //   const interval2 = setInterval(() => {
  //     if (state.DashboardOnboardOverviewCall.onboardingOverviewdata.completed_employee_percentage != 0) {
  //       setempVer((prevCount) => {
  //         if (
  //           prevCount <
  //           state.DashboardOnboardOverviewCall.onboardingOverviewdata.completed_employee_percentage
  //         ) {
  //           return prevCount + 1;
  //         } else {
  //           clearInterval(interval2);
  //           return prevCount;
  //         }
  //       });
  //     }
  //   }, 100);
  //   return () => clearInterval(interval2);
  // }, [state.DashboardOnboardOverviewCall.onboardingOverviewdata.completed_employee_percentage]);

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     if (state.DashboardOnboardOverviewCall.onboardingOverviewdata.pending_employee_percentage != null) {
  //       setPendignEmp((prevCount) => {
  //         if (
  //           prevCount <
  //           state.DashboardOnboardOverviewCall.onboardingOverviewdata.pending_employee_percentage
  //         ) {
  //           return prevCount + 1;
  //         } else {
  //           clearInterval(intervalId);
  //           return prevCount;
  //         }
  //       });
  //     }
  //   }, 100);
  //   return () => clearInterval(intervalId);
  // }, [state.DashboardOnboardOverviewCall.onboardingOverviewdata.pending_employee_percentage]);

  useEffect(() => {

     if(range.length > 0){
    const optionsDatas = {
      VerifiedEmpCount: state.DashboardOnboardOverviewCall.onboardingOverviewdata.completed_employee,
      DeclineEmpCount: state.DashboardOnboardOverviewCall.onboardingOverviewdata.decline_employee,

      PendingEmployeCount: state.DashboardOnboardOverviewCall.onboardingOverviewdata.pending_employee,

      VerifiedEmp: state.DashboardOnboardOverviewCall.onboardingOverviewdata.completed_employee_percentage,
      DeclineEmp: state.DashboardOnboardOverviewCall.onboardingOverviewdata.decline_employee_percentage,
      PendingEmploye: state.DashboardOnboardOverviewCall.onboardingOverviewdata.pending_employee_percentage,

      // VerifiedPayEmp: state.DashboardOnboardOverviewCall.onboardingOverviewdata.payroll_approved_percentage,
      // DeclinePayEmp: state.DashboardOnboardOverviewCall.onboardingOverviewdata.payroll_decline_percentage,
      // PendingPayEmploye:
      //   state.DashboardOnboardOverviewCall.onboardingOverviewdata.payroll_pending_percentage,
      EmployeeCounts: state.DashboardOnboardOverviewCall.onboardingOverviewdata.employee_count,

      VerifiedPayEmp: state.DashboardOnboardOverviewCall.onboardingOverviewdata.payroll_approved,
      DeclinePayEmp: state.DashboardOnboardOverviewCall.onboardingOverviewdata.payroll_decline,
      PendingPayEmploye: state.DashboardOnboardOverviewCall.onboardingOverviewdata.payroll_pending,

      PayRequestCount: state.DashboardOnboardOverviewCall.onboardingOverviewdata.payroll_request_count,

      // VerifiedRMEmp: state.DashboardOnboardOverviewCall.onboardingOverviewdata.rm_approved_percentage,
      // DeclineRMEmp: state.DashboardOnboardOverviewCall.onboardingOverviewdata.rm_decline_percentage,

      // PendingRMEmploye: state.DashboardOnboardOverviewCall.onboardingOverviewdata.rm_pending_percentage,

      RMRequestCount: state.DashboardOnboardOverviewCall.onboardingOverviewdata.rm_request_count,

      VerifiedRMEmp: state.DashboardOnboardOverviewCall.onboardingOverviewdata.rm_approved,
      DeclineRMEmp: state.DashboardOnboardOverviewCall.onboardingOverviewdata.rm_decline,

      PendingRMEmploye: state.DashboardOnboardOverviewCall.onboardingOverviewdata.rm_pending,
    };
    setPercentageData(optionsDatas);
    ////---t0 get the percentage

    const optionsDatasPercentage = {
      VerifiedEmpCount:
        state.DashboardOnboardOverviewCall.onboardingOverviewdata.completed_employee_percentage,
      DeclineEmpCount:
        state.DashboardOnboardOverviewCall.onboardingOverviewdata.decline_employee_percentage,

      PendingEmployeCount:
        state.DashboardOnboardOverviewCall.onboardingOverviewdata.pending_employee_percentage,

      VerifiedEmp: state.DashboardOnboardOverviewCall.onboardingOverviewdata.completed_employee_percentage,
      DeclineEmp: state.DashboardOnboardOverviewCall.onboardingOverviewdata.decline_employee_percentage,
      PendingEmploye: state.DashboardOnboardOverviewCall.onboardingOverviewdata.pending_employee_percentage,

      VerifiedPayEmp: state.DashboardOnboardOverviewCall.onboardingOverviewdata.payroll_approved_percentage,
      DeclinePayEmp: state.DashboardOnboardOverviewCall.onboardingOverviewdata.payroll_decline_percentage,
      PendingPayEmploye:
        state.DashboardOnboardOverviewCall.onboardingOverviewdata.payroll_pending_percentage,
      EmployeeCounts: state.DashboardOnboardOverviewCall.onboardingOverviewdata.employee_count,

      PayRequestCount: state.DashboardOnboardOverviewCall.onboardingOverviewdata.payroll_request_count,

      VerifiedRMEmp: state.DashboardOnboardOverviewCall.onboardingOverviewdata.rm_approved_percentage,
      DeclineRMEmp: state.DashboardOnboardOverviewCall.onboardingOverviewdata.rm_decline_percentage,

      PendingRMEmploye: state.DashboardOnboardOverviewCall.onboardingOverviewdata.rm_pending_percentage,

      RMRequestCount: state.DashboardOnboardOverviewCall.onboardingOverviewdata.rm_request_count,
    };

    setcountOfemployeeOnboard(optionsDatasPercentage);

  }
   else if(range.length == 0){

    const optionsDatas = {
      VerifiedEmpCount:0,
      DeclineEmpCount: 0,

      PendingEmployeCount: 0,

      VerifiedEmp: 0,
      DeclineEmp: 0,
      PendingEmploye: 0,

      // VerifiedPayEmp: state.DashboardOnboardOverviewCall.onboardingOverviewdata.payroll_approved_percentage,
      // DeclinePayEmp: state.DashboardOnboardOverviewCall.onboardingOverviewdata.payroll_decline_percentage,
      // PendingPayEmploye:
      //   state.DashboardOnboardOverviewCall.onboardingOverviewdata.payroll_pending_percentage,
      EmployeeCounts: 0,

      VerifiedPayEmp: 0,
      DeclinePayEmp: 0,
      PendingPayEmploye: 0,

      PayRequestCount: 0,

      // VerifiedRMEmp: state.DashboardOnboardOverviewCall.onboardingOverviewdata.rm_approved_percentage,
      // DeclineRMEmp: state.DashboardOnboardOverviewCall.onboardingOverviewdata.rm_decline_percentage,

      // PendingRMEmploye: state.DashboardOnboardOverviewCall.onboardingOverviewdata.rm_pending_percentage,

      RMRequestCount: 0,

      VerifiedRMEmp: 0,
      DeclineRMEmp: 0,

      PendingRMEmploye: 0,
    };
    setPercentageData(optionsDatas);
    ////---t0 get the percentage

    const optionsDatasPercentage = {
      VerifiedEmpCount:
        0,
      DeclineEmpCount:
        0,

      PendingEmployeCount:
        0,

      VerifiedEmp: 0,
      DeclineEmp: 0,
      PendingEmploye: 0,

      VerifiedPayEmp: 0,
      DeclinePayEmp: 0,
      PendingPayEmploye:
        0,
      EmployeeCounts: 0,

      PayRequestCount: 0,

      VerifiedRMEmp: 0,
      DeclineRMEmp: 0,

      PendingRMEmploye: 0,

      RMRequestCount: 0,
    };

    setcountOfemployeeOnboard(optionsDatasPercentage);



   }

    console.log(
      state.DashboardOnboardOverviewCall.onboardingOverviewdata.pending_employee_percentage,
      CountsofemployeeOnboard.PendingEmployeCount,
      "pending_employee_percentage"
    );
  }, [state.DashboardOnboardOverviewCall.onboardingOverviewdata, range]);

  ///---Kyc----pennding
  useEffect(() => {
    const interval2 = setInterval(() => {
      if (state.DashboardOnboardOverviewCall.onboardingOverviewdata.kyc_pending != 0) {
        setkycpending((prevCount) => {
          if (prevCount < state.DashboardOnboardOverviewCall.onboardingOverviewdata.kyc_pending) {
            return prevCount + 1;
          } else {
            clearInterval(interval2);
            return prevCount;
          }
        });
      }
    }, 100);
    return () => clearInterval(interval2);
  }, [state.DashboardOnboardOverviewCall.onboardingOverviewdata.kyc_pending]);

  ////------------employeeecounts-pending-----

  useEffect(() => {
    const interval3 = setInterval(() => {
      if (state.DashboardOnboardOverviewCall.onboardingOverviewdata.pending_employee != 0) {
        setPendingCounts((prevCount) => {
          if (prevCount < state.DashboardOnboardOverviewCall.onboardingOverviewdata.pending_employee) {
            return prevCount + 1;
          } else {
            clearInterval(interval3);
            return prevCount;
          }
        });
      }
    }, 100);
    return () => clearInterval(interval3);
  }, [state.DashboardOnboardOverviewCall.onboardingOverviewdata.pending_employee]);

  ////------------employeeecounts----veriried--

  useEffect(() => {
    const interval3 = setInterval(() => {
      if (state.DashboardOnboardOverviewCall.onboardingOverviewdata.completed_employee != 0) {
        setEmpVerifyed((prevCount) => {
          if (prevCount < state.DashboardOnboardOverviewCall.onboardingOverviewdata.completed_employee) {
            return prevCount + 1;
          } else {
            clearInterval(interval3);
            return prevCount;
          }
        });
      }
    }, 100);
    return () => clearInterval(interval3);
  }, [state.DashboardOnboardOverviewCall.onboardingOverviewdata.completed_employee]);

  ////------------employeeecounts----decline--

  useEffect(() => {
    const interval3 = setInterval(() => {
      if (state.DashboardOnboardOverviewCall.onboardingOverviewdata.decline_employee != 0) {
        setDeclineCount((prevCount) => {
          if (prevCount < state.DashboardOnboardOverviewCall.onboardingOverviewdata.decline_employee) {
            return prevCount + 1;
          } else {
            clearInterval(interval3);
            return prevCount;
          }
        });
      }
    }, 100);
    return () => clearInterval(interval3);
  }, [state.DashboardOnboardOverviewCall.onboardingOverviewdata.decline_employee]);

  ///---Branches------------------------------
  const data = { state: datas.state, region: datas.region, zone: datas.zone };

  useEffect(() => {
    const payload = {
      search: search,
      page_size: 20,
      page: dtpageindex,
      data: data,
            organization:Filterids?.organization

    };
    dispatch(setClientBranchSearchAction(payload));

    //  console.log(state.ClientBranch.ClientBranchess, "asdasd");
  }, [search, datas ,Filterids]);

  useEffect(() => {
    if (state.BranchSearchpart.BranchSearch != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });

      state.BranchSearchpart.BranchSearch.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.branch_code
          ? `${element.branch_code}-${element.client_name.toUpperCase()}`
          : element.client_name.toUpperCase(),        });
      });
      setOptions4(objectArray);
    }
  }, [state.BranchSearchpart.BranchSearch, search]);

  useDebouncedEffect(
    () => {
      if (setSearchDebounance) {
        setSearched({
          ...SearchedVal,
          stateSearch: SearchDebounance.stateSearch,
          regionSearch: SearchDebounance.regionSearch,
          zoneSearch: SearchDebounance.zoneSearch,
          organization_search:SearchDebounance.organization_search
        });
        setSearch(SearchDebounance.Clientsearch);

      }
    },
    500,
    [SearchDebounance]
  );

///-----State----Input Changes
const handleInputChange = (Val) => {
  setSearchDebounance({
    ...SearchDebounance,
    stateSearch: Val,

  });

};

///---Region-----------------
const handleInputRegion = (Val) => {
  setSearchDebounance({
    ...SearchDebounance,
    regionSearch: Val,
  });
};
///----Zone---Name
const handleInputZone = (Val) => {
  setSearchDebounance({
    ...SearchDebounance,
    zoneSearch:Val,
  });
};
  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(setTheAttendanceregionObject(selectedVal));
      dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));

      setData({
        ...datas,
        region: selectedVal.value,
      });
    }
    if (selectedVal == null) {
      setData({
        ...datas,
        region: "",
        zone: "",
      });

      dispatch(setTheAttendanceregionObject({ value: "", label: "ALL" }));
      dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));

      setMuliselect3({ value: "", label: "ALL" });

      setMuliselect1({ value: "", label: "ALL" });
    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    //console.log(selectedVal ,"selected Values");
    if (selectedVal != null) {
      setMuliselect3(selectedVal);
      setData({
        ...datas,
        zone: selectedVal.value,
      });

      dispatch(setTheAttendanceZoneObject(selectedVal));
    }
    if (selectedVal == null) {
      setData({
        ...datas,
        zone: "",
      });
      dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));

      setMuliselect3({ value: "", label: "ALL" });
    }
  };
  const handleSelectChange = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });

      setData({
        ...datas,
        state: selectedVal.value,
        zone: "",
        region: "",
      });
      setClients("");

      dispatch(SetTheDashboardonBoardOverViewClientList({ value: "", label: "ALL" }));

      dispatch(setTheAttendanceStateObject(selectedVal));
      dispatch(setTheAttendanceregionObject({ value: "", label: "ALL" }));

      dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));
    }
    if (selectedVal == null) {
      setMuliselect({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      setData({
        ...datas,
        state: "",
        zone: "",
        region: "",
      });
      setClients("");

      dispatch(setTheAttendanceStateObject({ value: "", label: "ALL" }));
      dispatch(setTheAttendanceregionObject({ value: "", label: "ALL" }));
      dispatch(SetTheDashboardonBoardOverViewClientList({ value: "", label: "ALL" }));

      dispatch(setTheEmployeeZoneName({ value: "", label: "ALL" }));
    }
  };

  // //----Region----------------
  // const handelRegionSlect = (selectedVal) => {
  //   if (selectedVal != null) {
  //     setMuliselect1(selectedVal);
  //     setMuliselect3([]);
  //     setData({
  //       ...datas,
  //       region: selectedVal.value,
  //     });
  //   }
  //   if (selectedVal == null) {
  //     setMuliselect1({ value: "", label: "All" });
  //     setMuliselect3({ value: "", label: "All" });
  //     setData({
  //       ...datas,
  //       region: "",
  //       zone: "",
  //     });
  //   }
  // };
  // //----------------Zone
  // const handleZone = (selectedVal) => {
  //   //console.log(selectedVal ,"selected Values");
  //   if (selectedVal != null) {
  //     setMuliselect3(selectedVal);
  //     setData({
  //       ...datas,
  //       zone: selectedVal.value,
  //     });
  //   }
  //   if (selectedVal == null) {
  //     setData({
  //       ...datas,
  //       zone: "",
  //     });
  //   }
  // };

    const handleInputOrganization = (Val)=>{
    setSearchDebounance({
      ...SearchDebounance,
      organization_search: Val,
    });
}

  const HandleClientBranches = (selectedVal) => {
    //  console.log(selectedVal, "selectedvalue", counts);
    dispatch(SetTheDashboardonBoardOverViewClientList(selectedVal));
    SetSelectValue(selectedVal);

    if (selectedVal != null) {
      //  console.log("in Search");
      setClients(selectedVal.value);
      SetSelectValue(selectedVal);
      setClientName(selectedVal.label);
    } else {
      setempVer(0);
      setCount(0);
      setPendignEmp(0);
      setDeclineEmp(0);
      ////counts
      setPendingCounts(0);

      setEmpVerifyed(0);
      setDeclineCount(0);
      ///-------------kyc pending
      setkycpending(0);

            setClients("");
      setClientName("");


          SetSelectValue({value: "", label: "ALL" });


      dispatch(SetTheDashboardonBoardOverViewClientList({ value: "", label: "ALL" }));
    }
  };


  const handlOrganizationList =(selected)=>{
  if(selected != null){ 
  dispatch(SetTheDashboardonBoardOverViewOrganizationListed_stateList(selected))
  setOrganization_Val(selected)
      setfilterids({
        ...Filterids,
        organization: selected?.value,
    });
  
  }
   else {
      dispatch(SetTheDashboardonBoardOverViewOrganizationListed_stateList({value:"",label:"ALL"}))
  setOrganization_Val({value:"",label:"ALL"})
      setfilterids({
        ...Filterids,
        organization: "",
    });
   }
      setempVer(0);
      setCount(0);
      setPendignEmp(0);
      setDeclineEmp(0);
      ////counts
      setPendingCounts(0);
setClients("");
setClientName("")
      setEmpVerifyed(0);
      setDeclineCount(0);
      ///-------------kyc pending
      setkycpending(0);

      dispatch(SetTheDashboardonBoardOverViewClientList({ value: "", label: "ALL" }));

}

  const HandleInputBranch = (e) => {
    setSearchDebounance({
      ...SearchDebounance,
      Clientsearch:e
    })
  };
  ///---All---Employee---List
  const HandleAllEmployees = (e) => {
    dispatch(setTheOnboardFromDateLIST(range[0]));
    dispatch(setOnboardTODtaeDASH(range[1]));
    dispatch(SetDashboards(2));

    if (
      multiselect != undefined &&
      multiselect1 != undefined &&
      multiselect3 != undefined
    ) {
      dispatch(
        setTheAttendanceStateObject(
          multiselect[0] ? multiselect[0] : multiselect
        )
      );
      dispatch(
        setTheAttendanceregionObject(
          multiselect1[0] ? multiselect1[0] : multiselect1
        )
      );

      dispatch(
        setTheAttendanceZoneObject(
          multiselect3[0] ? multiselect3[0] : multiselect3
        )
      );
    }
    if (
      multiselect1 != undefined ||
      multiselect1 != undefined ||
      multiselect3 != undefined
    ) {
      if (multiselect == undefined) {
        dispatch(setTheAttendanceStateObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceregionObject({ value: "",label: "ALL" }));
        dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));
      }
      if (multiselect1 == undefined) {
        dispatch(setTheAttendanceStateObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceregionObject({ value: "",label: "ALL" }));
      }
      if (multiselect3 == undefined) {
        dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));
      }
    }

    if (state.ClientBranchIDs.DashboardIDs == 2) {
      dispatch(getEmployeeBranchName(clientname));
      navigate("/employeeVerifylist");
    }

    dispatch(getSingleEmployeeActions(Client));

    dispatch(getEmployeeBranchName(clientname));
    dispatch(SetDashboards(2));
    // dispatch(getEmployeeBranchZones(id.client_id.zone_id.zone_name));
    // dispatch(getEmployeeEReuestlist(id.employee_request));
    //window.location.href = "/employeeVerifylist";
    dispatch(setDropDownRenders(""));
    dispatch(SettheAllOptions("1")); ///--set seacond dropdown value All
    dispatch(SettheCompletedOptions("2")); //----set a first dropdown value completed

    dispatch(SetthePendingOptions("3")); ////Pending
    dispatch(SettheDeclineOptions("4")); ///Decline
    dispatch(SettheApproveOptions("5")); //Approves

    if (state.NumberCounts.namerednder == "") {
      navigate("/employeeVerifylist");
    }
  };

  //---for the ---payrokkk--

  const HandleAllEmployeesPayrol = (e) => {
    dispatch(setTheOnboardFromDateLIST(range[0]));
    dispatch(setOnboardTODtaeDASH(range[1]));
    dispatch(SetDashboards(3));

    if (
      multiselect != undefined &&
      multiselect1 != undefined &&
      multiselect3 != undefined
    ) {
      dispatch(
        setTheAttendanceStateObject(
          multiselect[0] ? multiselect[0] : multiselect
        )
      );
      dispatch(
        setTheAttendanceregionObject(
          multiselect1[0] ? multiselect1[0] : multiselect1
        )
      );

      dispatch(
        setTheAttendanceZoneObject(
          multiselect3[0] ? multiselect3[0] : multiselect3
        )
      );
    }
    if (
      multiselect1 != undefined ||
      multiselect1 != undefined ||
      multiselect3 != undefined
    ) {
      if (multiselect == undefined) {
        dispatch(setTheAttendanceStateObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceregionObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));
      }
      if (multiselect1 == undefined) {
        dispatch(setTheAttendanceStateObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceregionObject({ value: "", label: "ALL" }));
      }
      if (multiselect3 == undefined) {
        dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));
      }
    }

    if (state.ClientBranchIDs.DashboardIDs == 2) {
      dispatch(getEmployeeBranchName(clientname));
      navigate("/employeeVerifylist");
    }

    dispatch(getSingleEmployeeActions(Client));

    dispatch(getEmployeeBranchName(clientname));
    dispatch(SetDashboards(3));

    dispatch(setDropDownRenders(""));
    dispatch(SettheAllOptions("1")); ///--set seacond dropdown value All
    dispatch(SettheCompletedOptions("2")); //----set a first dropdown value completed

    dispatch(SetthePendingOptions("3")); ////Pending
    dispatch(SettheDeclineOptions("4")); ///Decline
    dispatch(SettheApproveOptions("5")); //Approves

    if (state.NumberCounts.namerednder == "") {
      navigate("/employeeVerifylist");
    }
  };

  const HandleVerifiedemployeesPayroll = (e) => {
    dispatch(setTheOnboardFromDateLIST(range[0]));
    dispatch(setOnboardTODtaeDASH(range[1]));
    dispatch(SetDashboards(3));
    if (
      multiselect != undefined &&
      multiselect1 != undefined &&
      multiselect3 != undefined
    ) {
      dispatch(
        setTheAttendanceStateObject(
          multiselect[0] ? multiselect[0] : multiselect
        )
      );
      dispatch(
        setTheAttendanceregionObject(
          multiselect1[0] ? multiselect1[0] : multiselect1
        )
      );

      dispatch(
        setTheAttendanceZoneObject(
          multiselect3[0] ? multiselect3[0] : multiselect3
        )
      );
    }
    if (
      multiselect1 != undefined ||
      multiselect1 != undefined ||
      multiselect3 != undefined
    ) {
      if (multiselect == undefined) {
        dispatch(setTheAttendanceStateObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceregionObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));
      }
      if (multiselect1 == undefined) {
        dispatch(setTheAttendanceStateObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceregionObject({ value: "", label: "ALL" }));
      }
      if (multiselect3 == undefined) {
        dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));
      }
    }
    if (Client == null || Client == undefined) {
      dispatch(SetDashboards(3));
      if (state.ClientBranchIDs.DashboardIDs == 2) {
        dispatch(getEmployeeBranchName(clientname));
        navigate("/employeeVerifylist");
      }
    }

    dispatch(getSingleEmployeeActions(Client));

    dispatch(getEmployeeBranchName(clientname));

    dispatch(SettheCompletedOptions("1")); //----set a first dropdown value completed
    dispatch(SettheAllOptions("2")); ///--set seacond dropdown value All
    dispatch(setDropDownRenders("completed"));
    if (state.NumberCounts.namerednder == "completed") {
      navigate("/employeeVerifylist");
    }
  };

  const HandlePendngPArollEmployess = (e) => {
    dispatch(setTheOnboardFromDateLIST(range[0]));
    dispatch(setOnboardTODtaeDASH(range[1]));

    dispatch(SetDashboards(3));
    if (
      multiselect != undefined &&
      multiselect1 != undefined &&
      multiselect3 != undefined
    ) {
      dispatch(
        setTheAttendanceStateObject(
          multiselect[0] ? multiselect[0] : multiselect
        )
      );
      dispatch(
        setTheAttendanceregionObject(
          multiselect1[0] ? multiselect1[0] : multiselect1
        )
      );

      dispatch(
        setTheAttendanceZoneObject(
          multiselect3[0] ? multiselect3[0] : multiselect3
        )
      );
    }
    if (
      multiselect1 != undefined ||
      multiselect1 != undefined ||
      multiselect3 != undefined
    ) {
      if (multiselect == undefined) {
        dispatch(setTheAttendanceStateObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceregionObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));
      }
      if (multiselect1 == undefined) {
        dispatch(setTheAttendanceStateObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceregionObject({ value: "", label: "ALL" }));
      }
      if (multiselect3 == undefined) {
        dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));
      }
    }

    if (Client == null || Client == undefined || Client == "") {
      if (state.ClientBranchIDs.DashboardIDs == 2) {
        dispatch(SetDashboards(3));
        navigate("/employeeVerifylist");
        dispatch(getSingleEmployeeActions(Client));
      }
    }

    dispatch(getSingleEmployeeActions(Client));

    dispatch(getSingleEmployeeActions(Client));
    dispatch(setDropDownRenders("Pending"));
    dispatch(getEmployeeBranchName(clientname));

    // dispatch(getEmployeeBranchZones(id.client_id.zone_id.zone_name));
    // dispatch(getEmployeeEReuestlist(id.employee_request));
    //window.location.href = "/employeeVerifylist";
    dispatch(SetthePendingOptions("1"));
    dispatch(SettheDeclineOptions("4")); //----set a first dropdown value Declined Employees
    dispatch(SettheAllOptions("2")); ///--set seacond dropdown value All
    dispatch(SettheCompletedOptions("3")); //----set a first dropdown value completed

    if (state.NumberCounts.namerednder == "Pending") {
      navigate("/employeeVerifylist");
    }
  };
  ///---Verified----Employees
  const HandleVerifiedemployees = () => {
    dispatch(setTheOnboardFromDateLIST(range[0]));
    dispatch(setOnboardTODtaeDASH(range[1]));
    dispatch(SetDashboards(2));
    if (
      multiselect != undefined &&
      multiselect1 != undefined &&
      multiselect3 != undefined
    ) {
      dispatch(
        setTheAttendanceStateObject(
          multiselect[0] ? multiselect[0] : multiselect
        )
      );
      dispatch(
        setTheAttendanceregionObject(
          multiselect1[0] ? multiselect1[0] : multiselect1
        )
      );

      dispatch(
        setTheAttendanceZoneObject(
          multiselect3[0] ? multiselect3[0] : multiselect3
        )
      );
    }
    if (
      multiselect1 != undefined ||
      multiselect1 != undefined ||
      multiselect3 != undefined
    ) {
      if (multiselect == undefined) {
        dispatch(setTheAttendanceStateObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceregionObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));
      }
      if (multiselect1 == undefined) {
        dispatch(setTheAttendanceStateObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceregionObject({ value: "", label: "ALL" }));
      }
      if (multiselect3 == undefined) {
        dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));
      }
    }

    if (Client == null || Client == undefined) {
      dispatch(SetDashboards(2));
      if (state.ClientBranchIDs.DashboardIDs == 2) {
        dispatch(getEmployeeBranchName(clientname));
        navigate("/employeeVerifylist");
      }
    }

    dispatch(getSingleEmployeeActions(Client));

    dispatch(getEmployeeBranchName(clientname));

    dispatch(SettheCompletedOptions("1")); //----set a first dropdown value completed
    dispatch(SettheAllOptions("2")); ///--set seacond dropdown value All
    dispatch(setDropDownRenders("completed"));
    if (state.NumberCounts.namerednder == "completed") {
      navigate("/employeeVerifylist");
    }
  };

  const HandledecineEmpPayroll = (e) => {
    dispatch(setTheOnboardFromDateLIST(range[0]));
    dispatch(setOnboardTODtaeDASH(range[1]));
    dispatch(SetDashboards(3));
    if (
      multiselect != undefined &&
      multiselect1 != undefined &&
      multiselect3 != undefined
    ) {
      dispatch(
        setTheAttendanceStateObject(
          multiselect[0] ? multiselect[0] : multiselect
        )
      );
      dispatch(
        setTheAttendanceregionObject(
          multiselect1[0] ? multiselect1[0] : multiselect1
        )
      );

      dispatch(
        setTheAttendanceZoneObject(
          multiselect3[0] ? multiselect3[0] : multiselect3
        )
      );
    }
    if (
      multiselect1 != undefined ||
      multiselect1 != undefined ||
      multiselect3 != undefined
    ) {
      if (multiselect == undefined) {
        dispatch(setTheAttendanceStateObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceregionObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));
      }
      if (multiselect1 == undefined) {
        dispatch(setTheAttendanceStateObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceregionObject({ value: "", label: "ALL" }));
      }
      if (multiselect3 == undefined) {
        dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));
      }
    }

    if (Client == null || Client == undefined) {
      dispatch(SetDashboards(3));

      if (state.ClientBranchIDs.DashboardIDs == 2) {
        dispatch(getEmployeeBranchName(clientname));
        navigate("/employeeVerifylist");
      }
    }

    dispatch(getSingleEmployeeActions(Client));

    dispatch(getEmployeeBranchName(clientname));

    dispatch(SettheDeclineOptions("1")); //----set a first dropdown value Declined Employees
    dispatch(SettheAllOptions("2")); ///--set seacond dropdown value All
    dispatch(SettheCompletedOptions("3")); //----set a first dropdown value completed
    dispatch(setDropDownRenders("Decline"));
    if (state.NumberCounts.namerednder == "Decline") {
      navigate("/employeeVerifylist");
    }
  };

  //-------All Employees------------------
  const HandleAllEmployeesRM = (e) => {
    dispatch(setTheOnboardFromDateLIST(range[0]));
    dispatch(setOnboardTODtaeDASH(range[1]));
    dispatch(SetDashboards(4));
    if (
      multiselect != undefined &&
      multiselect1 != undefined &&
      multiselect3 != undefined
    ) {
      dispatch(
        setTheAttendanceStateObject(
          multiselect[0] ? multiselect[0] : multiselect
        )
      );
      dispatch(
        setTheAttendanceregionObject(
          multiselect1[0] ? multiselect1[0] : multiselect1
        )
      );

      dispatch(
        setTheAttendanceZoneObject(
          multiselect3[0] ? multiselect3[0] : multiselect3
        )
      );
    }
    if (
      multiselect1 != undefined ||
      multiselect1 != undefined ||
      multiselect3 != undefined
    ) {
      if (multiselect == undefined) {
        dispatch(setTheAttendanceStateObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceregionObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));
      }
      if (multiselect1 == undefined) {
        dispatch(setTheAttendanceStateObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceregionObject({ value: "", label: "ALL" }));
      }
      if (multiselect3 == undefined) {
        dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));
      }
    }
    if (state.ClientBranchIDs.DashboardIDs == 2) {
      dispatch(getEmployeeBranchName(clientname));
      navigate("/employeeVerifylist");
    }

    dispatch(getSingleEmployeeActions(Client));

    dispatch(getEmployeeBranchName(clientname));
    dispatch(SetDashboards(4));

    dispatch(setDropDownRenders(""));
    dispatch(SettheAllOptions("1")); ///--set seacond dropdown value All
    dispatch(SettheCompletedOptions("2")); //----set a first dropdown value completed

    dispatch(SetthePendingOptions("3")); ////Pending
    dispatch(SettheDeclineOptions("4")); ///Decline
    dispatch(SettheApproveOptions("5")); //Approves

    if (state.NumberCounts.namerednder == "") {
      navigate("/employeeVerifylist");
    }
  };

  const HandledecineEmpPayrRM = (e) => {
    dispatch(setTheOnboardFromDateLIST(range[0]));
    dispatch(setOnboardTODtaeDASH(range[1]));
    dispatch(SetDashboards(4));

    if (
      multiselect != undefined &&
      multiselect1 != undefined &&
      multiselect3 != undefined
    ) {
      dispatch(
        setTheAttendanceStateObject(
          multiselect[0] ? multiselect[0] : multiselect
        )
      );
      dispatch(
        setTheAttendanceregionObject(
          multiselect1[0] ? multiselect1[0] : multiselect1
        )
      );

      dispatch(
        setTheAttendanceZoneObject(
          multiselect3[0] ? multiselect3[0] : multiselect3
        )
      );
    }
    if (
      multiselect1 != undefined ||
      multiselect1 != undefined ||
      multiselect3 != undefined
    ) {
      if (multiselect == undefined) {
        dispatch(setTheAttendanceStateObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceregionObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));
      }
      if (multiselect1 == undefined) {
        dispatch(setTheAttendanceStateObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceregionObject({ value: "", label: "ALL" }));
      }
      if (multiselect3 == undefined) {
        dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));
      }
    }

    if (Client == null || Client == undefined) {
      dispatch(SetDashboards(4));

      if (state.ClientBranchIDs.DashboardIDs == 2) {
        dispatch(getEmployeeBranchName(clientname));
        navigate("/employeeVerifylist");
      }
    }

    dispatch(getSingleEmployeeActions(Client));

    dispatch(getEmployeeBranchName(clientname));

    dispatch(SettheDeclineOptions("1")); //----set a first dropdown value Declined Employees
    dispatch(SettheAllOptions("2")); ///--set seacond dropdown value All
    dispatch(SettheCompletedOptions("3")); //----set a first dropdown value completed
    dispatch(setDropDownRenders("Decline"));
    if (state.NumberCounts.namerednder == "Decline") {
      navigate("/employeeVerifylist");
    }
  };

  const HandlePendngRMEmployess = (e) => {
    dispatch(setTheOnboardFromDateLIST(range[0]));
    dispatch(setOnboardTODtaeDASH(range[1]));

    dispatch(SetDashboards(4));
    if (
      multiselect != undefined &&
      multiselect1 != undefined &&
      multiselect3 != undefined
    ) {
      dispatch(
        setTheAttendanceStateObject(
          multiselect[0] ? multiselect[0] : multiselect
        )
      );
      dispatch(
        setTheAttendanceregionObject(
          multiselect1[0] ? multiselect1[0] : multiselect1
        )
      );

      dispatch(
        setTheAttendanceZoneObject(
          multiselect3[0] ? multiselect3[0] : multiselect3
        )
      );
    }
    if (
      multiselect1 != undefined ||
      multiselect1 != undefined ||
      multiselect3 != undefined
    ) {
      if (multiselect == undefined) {
        dispatch(setTheAttendanceStateObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceregionObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));
      }
      if (multiselect1 == undefined) {
        dispatch(setTheAttendanceStateObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceregionObject({ value: "", label: "ALL" }));
      }
      if (multiselect3 == undefined) {
        dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));
      }
    }

    if (Client == null || Client == undefined || Client == "") {
      if (state.ClientBranchIDs.DashboardIDs == 2) {
        dispatch(SetDashboards(4));
        navigate("/employeeVerifylist");
        dispatch(getSingleEmployeeActions(Client));
      }
    }

    dispatch(getSingleEmployeeActions(Client));

    dispatch(getSingleEmployeeActions(Client));
    dispatch(setDropDownRenders("Pending"));
    dispatch(getEmployeeBranchName(clientname));

    // dispatch(getEmployeeBranchZones(id.client_id.zone_id.zone_name));
    // dispatch(getEmployeeEReuestlist(id.employee_request));
    //window.location.href = "/employeeVerifylist";
    dispatch(SetthePendingOptions("1"));
    dispatch(SettheDeclineOptions("4")); //----set a first dropdown value Declined Employees
    dispatch(SettheAllOptions("2")); ///--set seacond dropdown value All
    dispatch(SettheCompletedOptions("3")); //----set a first dropdown value completed

    if (state.NumberCounts.namerednder == "Pending") {
      navigate("/employeeVerifylist");
    }
  };
  const HandleVerifiedemployeesRM = (e) => {
    dispatch(setTheOnboardFromDateLIST(range[0]));
    dispatch(setOnboardTODtaeDASH(range[1]));
    dispatch(SetDashboards(4));

    if (
      multiselect != undefined &&
      multiselect1 != undefined &&
      multiselect3 != undefined
    ) {
      dispatch(
        setTheAttendanceStateObject(
          multiselect[0] ? multiselect[0] : multiselect
        )
      );
      dispatch(
        setTheAttendanceregionObject(
          multiselect1[0] ? multiselect1[0] : multiselect1
        )
      );

      dispatch(
        setTheAttendanceZoneObject(
          multiselect3[0] ? multiselect3[0] : multiselect3
        )
      );
    }
    if (
      multiselect1 != undefined ||
      multiselect1 != undefined ||
      multiselect3 != undefined
    ) {
      if (multiselect == undefined) {
        dispatch(setTheAttendanceStateObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceregionObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));
      }
      if (multiselect1 == undefined) {
        dispatch(setTheAttendanceStateObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceregionObject({ value: "", label: "ALL" }));
      }
      if (multiselect3 == undefined) {
        dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));
      }
    }

    if (Client == null || Client == undefined) {
      dispatch(SetDashboards(4));
      if (state.ClientBranchIDs.DashboardIDs == 2) {
        dispatch(getEmployeeBranchName(clientname));
        navigate("/employeeVerifylist");
      }
    }

    dispatch(getSingleEmployeeActions(Client));

    dispatch(getEmployeeBranchName(clientname));

    dispatch(SettheCompletedOptions("1")); //----set a first dropdown value completed
    dispatch(SettheAllOptions("2")); ///--set seacond dropdown value All
    dispatch(setDropDownRenders("completed"));
    if (state.NumberCounts.namerednder == "completed") {
      navigate("/employeeVerifylist");
    }
  };

  const HandledecineEmp = () => {
    dispatch(setTheOnboardFromDateLIST(range[0]));
    dispatch(setOnboardTODtaeDASH(range[1]));
    dispatch(SetDashboards(2));
    if (
      multiselect != undefined &&
      multiselect1 != undefined &&
      multiselect3 != undefined
    ) {
      dispatch(
        setTheAttendanceStateObject(
          multiselect[0] ? multiselect[0] : multiselect
        )
      );
      dispatch(
        setTheAttendanceregionObject(
          multiselect1[0] ? multiselect1[0] : multiselect1
        )
      );

      dispatch(
        setTheAttendanceZoneObject(
          multiselect3[0] ? multiselect3[0] : multiselect3
        )
      );
    }
    if (
      multiselect1 != undefined ||
      multiselect1 != undefined ||
      multiselect3 != undefined
    ) {
      if (multiselect == undefined) {
        dispatch(setTheAttendanceStateObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceregionObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));
      }
      if (multiselect1 == undefined) {
        dispatch(setTheAttendanceStateObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceregionObject({ value: "", label: "ALL" }));
      }
      if (multiselect3 == undefined) {
        dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));
      }
    }

    if (Client == null || Client == undefined) {
      dispatch(SetDashboards(2));

      if (state.ClientBranchIDs.DashboardIDs == 2) {
        dispatch(getEmployeeBranchName(clientname));
        navigate("/employeeVerifylist");
      }
    }

    dispatch(getSingleEmployeeActions(Client));

    dispatch(getEmployeeBranchName(clientname));

    dispatch(SettheDeclineOptions("1")); //----set a first dropdown value Declined Employees
    dispatch(SettheAllOptions("2")); ///--set seacond dropdown value All
    dispatch(SettheCompletedOptions("3")); //----set a first dropdown value completed
    dispatch(setDropDownRenders("Decline"));
    if (state.NumberCounts.namerednder == "Decline") {
      navigate("/employeeVerifylist");
    }
  };

   useEffect(()=>{
     if(range.length > 0 && !range.includes("NaN-aN-aN")){ 
    dispatch(setTheOnboardFromDateLIST(range[0]));
    dispatch(setOnboardTODtaeDASH(range[1]));
     }
         if(state.EmployeeVerificationsNeed.ONboardFROMDATE ==""){
               dispatch(setTheOnboardFromDateLIST(today_day));
           dispatch(setOnboardTODtaeDASH(today_day));
         }

   },[range])
  const HandlePendngEmployess = () => {
    dispatch(setTheOnboardFromDateLIST(range[0]));
    dispatch(setOnboardTODtaeDASH(range[1]));

    dispatch(SetDashboards(2));

    if (
      multiselect != undefined &&
      multiselect1 != undefined &&
      multiselect3 != undefined
    ) {
      dispatch(
        setTheAttendanceStateObject(
          multiselect[0] ? multiselect[0] : multiselect
        )
      );
      dispatch(
        setTheAttendanceregionObject(
          multiselect1[0] ? multiselect1[0] : multiselect1
        )
      );

      dispatch(
        setTheAttendanceZoneObject(
          multiselect3[0] ? multiselect3[0] : multiselect3
        )
      );
    }
    if (
      multiselect1 != undefined ||
      multiselect1 != undefined ||
      multiselect3 != undefined
    ) {
      if (multiselect == undefined) {
        dispatch(setTheAttendanceStateObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceregionObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));
      }
      if (multiselect1 == undefined) {
        dispatch(setTheAttendanceStateObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceregionObject({ value: "", label: "ALL" }));
      }
      if (multiselect3 == undefined) {
        dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));
      }
    }
    if (Client == null || Client == undefined || Client == "") {
      if (state.ClientBranchIDs.DashboardIDs == 2) {
        dispatch(SetDashboards(2));
        navigate("/employeeVerifylist");
        dispatch(getSingleEmployeeActions(Client));
      }
    }

    dispatch(getSingleEmployeeActions(Client));

    dispatch(getSingleEmployeeActions(Client));
    dispatch(setDropDownRenders("Pending"));
    dispatch(getEmployeeBranchName(clientname));

    // dispatch(getEmployeeBranchZones(id.client_id.zone_id.zone_name));
    // dispatch(getEmployeeEReuestlist(id.employee_request));
    //window.location.href = "/employeeVerifylist";
    dispatch(SetthePendingOptions("1"));
    dispatch(SettheDeclineOptions("4")); //----set a first dropdown value Declined Employees
    dispatch(SettheAllOptions("2")); ///--set seacond dropdown value All
    dispatch(SettheCompletedOptions("3")); //----set a first dropdown value completed

    if (state.NumberCounts.namerednder == "Pending") {
      navigate("/employeeVerifylist");
    }
  };
  //----Handle----Date=-----Changes---
  const handlechangedate = (value) => {
    console.log(value, "vlues");
    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
      setdatest(true);

      setdatefilter({
        ...datefilter,
        from_date: range[0],
        to_date: range[1],
        range: true,
      });

      // console.log(datefilter, "datefilter");
    }
  };

  const size = {
    width: 600,
    height: 200,
  };

  //// testing
  const datapie = [
    {
      id: 0,
      // value: Rmpending,
      value: 12,

      label: "Rm Pending Employees",
      color: "green",
    },
    {
      id: 1,
      value: payrolpen,
      label: "PayRoll pending",
      // color: "blue"
    },
    // {
    //   id: 2,
    //   value: declineemp,
    //   label: "Declined Employees",
    //   color: "red",
    // },

    // {
    //   id: 3,
    //   value: PendingEmp,
    //   label: "Pending Employees",
    //   color: "red",
    // },
  ];

  const seriesConfig = {
    arcLabel: (item) => `${item.value}%`,
    // arcLabelMinAngle: 45,
    data: datapie, // Pass the 'datapie' as the 'data' prop
    // highlightScope: { faded: "global", highlighted: "item" },
    // faded: { innerRadius: 30, additionalRadius: -30, color: "gray" },
  };

  const dataonboard = [
    {
      id: 0,
      value: employeVerify,
      label: "Verified Employees",
      color: "green",
    },
    {
      id: 1,
      value: count,
      label: "Employees",
    },
    {
      id: 2,
      value: declineemp,
      label: "Declined Employees",
      color: "red",
    },

    {
      id: 3,
      value: PendingEmp,
      label: "Pending Employees",
      color: "red",
    },
  ];

  const seriesConfigonboard = {
    arcLabel: (item) => `${item.value}%`,
    // arcLabelMinAngle: 45,
    data: dataonboard, // Pass the 'datapie' as the 'data' prop
    // highlightScope: { faded: "global", highlighted: "item" },
    // faded: { innerRadius: 30, additionalRadius: -30, color: "gray" },
  };

  useEffect(() => {
    if (
      state.DashboardOnboardOverviewCall.onboardingOverviewdata.payroll_decline_percentage == 0 &&
      state.DashboardOnboardOverviewCall.onboardingOverviewdata.payroll_pending_percentage == 0 &&
      state.DashboardOnboardOverviewCall.onboardingOverviewdata.payroll_approved_percentage == 0
    ) {
      setPayrolstatus(true);
    } else if (
      state.DashboardOnboardOverviewCall.onboardingOverviewdata.payroll_decline_percentage == 0 ||
      state.DashboardOnboardOverviewCall.onboardingOverviewdata.payroll_pending_percentage != 0 ||
      state.DashboardOnboardOverviewCall.onboardingOverviewdata.payroll_approved_percentage == 0
    ) {
      setPayrolstatus(false);
    }

    if (state.DashboardOnboardOverviewCall.onboardingOverviewdata != null) {
      if (
        state.DashboardOnboardOverviewCall.onboardingOverviewdata.completed_employee == 0 &&
        state.DashboardOnboardOverviewCall.onboardingOverviewdata.decline_employee_percentage == 0 &&
        state.DashboardOnboardOverviewCall.onboardingOverviewdata.pending_employee_percentage == 0
      ) {
        setFindZero(true);
      } else if (
        state.DashboardOnboardOverviewCall.onboardingOverviewdata.completed_employee != 0 ||
        state.DashboardOnboardOverviewCall.onboardingOverviewdata.decline_employee_percentage == 0 ||
        state.DashboardOnboardOverviewCall.onboardingOverviewdata.pending_employee_percentage != 0
      ) {
        setFindZero(false);
      }
    }

    if (
      state.DashboardOnboardOverviewCall.onboardingOverviewdata.rm_approved_percentage == 0 &&
      state.DashboardOnboardOverviewCall.onboardingOverviewdata.rm_decline_percentage == 0 &&
      state.DashboardOnboardOverviewCall.onboardingOverviewdata.rm_pending_percentage == 0
    ) {
      setRMStatus(true);
    } else if (
      state.DashboardOnboardOverviewCall.onboardingOverviewdata.rm_approved_percentage == 0 ||
      state.DashboardOnboardOverviewCall.onboardingOverviewdata.rm_decline_percentage == 0 ||
      state.DashboardOnboardOverviewCall.onboardingOverviewdata.rm_pending_percentage == 0
    ) {
      setRMStatus(false);
    }
  }, [state.DashboardOnboardOverviewCall.onboardingOverviewdata]);

  // const pie_chart_data_Dia = [
  //   ["Onboarding", "count"],
  //   ["Verified Employees", employeVerify],
  //   ["Declined Employees", declineemp],
  //   ["Pending Employees", PendingEmp],
  // ];

  const pie_chart_data_Dia = [
    ["Onboarding", "count"],
    ["Verified Employees", Perecentagedata.VerifiedEmp],
    ["Declined Employees", Perecentagedata.DeclineEmp],
    ["Pending Employees", Perecentagedata.PendingEmploye],
    // ["Samples Collected", 67],
  ];
  
  
  const options_dia = {
    title: "All Onboard Details",
    pieHole: 0.5,
    is3D: false,
    slices: {
      // 1: { color: "grey" },
      // 3: { color: "green" },
      // 1: { color: "#11734B" },
      // 2: { color: "red" },
      // 3: { color: "dark red" },
      0: { color: "#11734B" }, // Green for Verified Employees
      1: { color: "blue" }, // Blue for Declined Employees
      2: { color: "red" }, // Red for Pending Employees
    },

    titleTextStyle: {
      fontSize: 16, // Title font size
    },
    legend: {
      textStyle: {
        fontSize: 13, // Legend font size
      },
    },
    tooltip: {
      textStyle: {
        fontSize: 13, // Tooltip font size
      },
    },
    chartArea: {
      // width: '90%', // Adjust chart area to fit better
      // height: '70%',
      width: "90%", // Adjust chart area to fit better
      height: "80%",
      top: 50, // Adjust top margin to create space for the title
    },
  };

  ///---rm
  // const DatasRM = [
  //   ["RmDatas", "count"],
  //   ["Verified Employees", RmApprove],
  //   ["Declined Employees", Rmdecline],
  //   ["Pending Employees", Rmpending],
  // ];
  const DatasRM = [
    ["RmDatas", "count"],
    ["Verified Employees", Perecentagedata.VerifiedRMEmp],
    ["Declined Employees", Perecentagedata.DeclineRMEmp],
    ["Pending Employees", Perecentagedata.PendingRMEmploye],
  ];

  const options_Rmdatas = {
    // title: "Payroll Report",
    title: "RM Report",

    pieHole: 0.5,
    is3D: false,
    slices: {
      // 1: { color: "grey" },
      // 3: { color: "green" },
      // 1: { color: "grey" },
      // 2: { color: "red" },
      // 3: { color: "#11734B" },

      0: { color: "#11734B" }, // Green for Verified Employees
      1: { color: "blue" }, // Blue for Declined Employees
      2: { color: "red" }, // Red for Pending Employees
    },

    titleTextStyle: {
      fontSize: 16, // Title font size
    },
    legend: {
      textStyle: {
        fontSize: 13, // Legend font size
      },
    },
    tooltip: {
      textStyle: {
        fontSize: 13, // Tooltip font size
      },
    },
    chartArea: {
      // width: '90%', // Adjust chart area to fit better
      // height: '70%',
      width: "90%", // Adjust chart area to fit better
      height: "80%",
      top: 50, // Adjust top margin to create space for the title
    },
  };
  ///---PayRoll
  // const DatasPayRoll = [
  //   ["payroll", "count"],
  //   ["Verified Employees", payrollVerifrf],
  //   ["Declined Employees", payroldecline],
  //   ["Pending Employees", payrolpen],
  // ];

  const DatasPayRoll = [
    ["payroll", "count"],
    ["Verified Employees", Perecentagedata.VerifiedPayEmp],
    ["Declined Employees", Perecentagedata.DeclinePayEmp],
    ["Pending Employees", Perecentagedata.PendingPayEmploye],
  ];

  const options_payrollData = {
    title: "Payroll Report",

    pieHole: 0.5,
    is3D: false,
    slices: {
      // 1: { color: "#11734B" },
      // 2: { color: "red" },
      // 3: { color: "dark red" },
      0: { color: "#11734B" }, // Green for Verified Employees
      1: { color: "blue" }, // Blue for Declined Employees
      2: { color: "red" }, // Red for Pending Employees
    },

    titleTextStyle: {
      fontSize: 14, // Title font size
    },
    legend: {
      textStyle: {
        fontSize: 13, // Legend font size
      },
    },
    tooltip: {
      textStyle: {
        fontSize: 13, // Tooltip font size
      },
    },
    chartArea: {
      // width: '90%', // Adjust chart area to fit better
      // height: '70%',
      width: "90%", // Adjust chart area to fit better
      height: "80%",
      top: 50, // Adjust top margin to create space for the title
    },
  };

  const cleaningrange = () => {
    //setrange([gt,it]);
  };

  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last week",
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },
  ];
  const HandleClick = (e, value) => {
    const data = [
      ["Branch Name", clientname, "From Date", range[0], "To Date", range[1]],

      // ["Onboarding", "Percentage"],
      ["", "", "ONBOARDING", "", ""],

      ["SNO", "STATUS", "COUNT", "PERCENTAGE"],

      [
        "1",
        "Employees",
        Perecentagedata.EmployeeCounts,
        CountsofemployeeOnboard.EmployeeCounts,
      ],

      [
        "2",
        "Verified Employees",
        Perecentagedata.VerifiedEmpCount,
        CountsofemployeeOnboard.VerifiedEmpCount,
      ],
      [
        "3",
        "Declined Employees",
        Perecentagedata.DeclineEmpCount,
        CountsofemployeeOnboard.DeclineEmpCount,
      ],
      [
        "4",
        "Pending Employees",
        Perecentagedata.PendingEmployeCount,
        CountsofemployeeOnboard.PendingEmployeCount,
      ],

      ["", "", "PAYROLL", "", ""],

      ["SNO", "STATUS", "COUNT", "PERCENTAGE"],

      [
        "1",
        "Request",
        Perecentagedata.PayRequestCount,
        CountsofemployeeOnboard.PayRequestCount,
      ],

      [
        "2",
        "Verified Employees",
        Perecentagedata.VerifiedPayEmp,
        CountsofemployeeOnboard.VerifiedPayEmp,
      ],
      [
        "3",
        "Declined Employees",
        Perecentagedata.DeclinePayEmp,
        CountsofemployeeOnboard.DeclinePayEmp,
      ],
      [
        "4",
        "Pending Employees",
        Perecentagedata.PendingPayEmploye,
        CountsofemployeeOnboard.PendingPayEmploye,
      ],

      ["", "", "RM DETAILS", "", ""],

      ["SNO", "STATUS", "COUNT", "PERCENTAGE"],

      [
        "1",
        "Request",
        Perecentagedata.RMRequestCount,
        CountsofemployeeOnboard.RMRequestCount,
      ],

      [
        "2",
        "Verified Employees",
        Perecentagedata.VerifiedRMEmp,
        CountsofemployeeOnboard.VerifiedRMEmp,
      ],
      [
        "3",
        "Declined Employees",
        Perecentagedata.DeclineRMEmp,
        CountsofemployeeOnboard.DeclineRMEmp,
      ],
      [
        "4",
        "Pending Employees",
        Perecentagedata.PendingRMEmploye,
        CountsofemployeeOnboard.PendingRMEmploye,
      ],
    ];

    // Create a new workbook and add a worksheet
    const ws = XLSX.utils.aoa_to_sheet(data);
    Object.keys(ws).forEach((key) => {
      if (key[0] !== "!") {
        // Exclude special keys such as "!ref"
        ws[key].s = {
          alignment: {
            horizontal: "center",
          },
        };
      }
    });
    // Set column widths
    ws["!cols"] = [
      { wpx: 100 }, // Width in pixels
      { wch: 20 }, // Width in characters
      // Add more columns as needed
    ];

    // Set row heights
    ws["!rows"] = [
      { hpx: 25 }, // Height in pixels
      { hpt: 20 }, // Height in points
      // Add more rows as needed
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Generate Excel file and trigger a download
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const dataBlob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(dataBlob, `${range[0] + "-" + range[1]}OnboardingSheet.xlsx`);
  };


  useEffect(() => {
    if (range.includes("NaN-aN-aN")) {
      setrange([]);
    } else if (range.length === 0) {
      // Do something if the list is already empty
      console.log("The list is already empty");
    }
  }, []);


  const openMe = ()=>{
    const rsAnimFade = document.querySelector('.rs-anim-fade');
    if (rsAnimFade) {
      rsAnimFade.style.setProperty('left', '872.34px', 'important');
      rsAnimFade.style.setProperty('top', '186.109px', 'important');   
    }
   }
  
   const CloseDateRange = ()=>{
    const rsAnimFade = document.querySelector('.rs-anim-fade');
    if (rsAnimFade) {
      rsAnimFade.style.setProperty('display', 'none', 'important');
      // rsAnimFade.style.setProperty('top', '184.109px', 'important');   
    }
   }
   const getZoomFactor = () => {
  const zoom = document.body.style.zoom;
  return zoom ? parseFloat(zoom) / 100 : 1;
};

const alignDateRangePicker = (pickerNode) => {
  const picker =
    pickerNode?.root || pickerNode?.container || pickerNode;

  const popup = document.querySelector(
    ".rs-picker-popup.rs-picker-popup-daterange"
  );

  if (!picker || !popup) return;

  const zoom = getZoomFactor();
  const rect = picker.getBoundingClientRect();

  const popupWidth = popup.offsetWidth;
  const popupHeight = popup.offsetHeight;

  const viewportWidth = window.innerWidth / zoom;
  const viewportHeight = window.innerHeight / zoom;

  const scrollX = window.scrollX / zoom;
  const scrollY = window.scrollY / zoom;

  let left = rect.right / zoom - popupWidth + scrollX;
  let top = rect.bottom / zoom + 8 + scrollY;

  if (left < 8) left = 8;
  if (left + popupWidth > viewportWidth - 8) {
    left = viewportWidth - popupWidth - 8;
  }

  if (top + popupHeight > viewportHeight + scrollY - 8) {
    top = rect.top / zoom - popupHeight - 8 + scrollY;
  }

  popup.style.position = "absolute";
  popup.style.left = `${left}px`;
  popup.style.top = `${top}px`;
};


  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            // className="InnerUsers col-md-6"
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            {RoleBased != undefined ? (
              <h2 class="user-name mb-0 WelcomeContent">{`Welcome ${capitalizeFirstLetter(
                RoleBased
              )}! `}</h2>
            ) : null}
            {/* <ul class="breadcrumb">
              <li class="breadcrumb-item">Onboard Overview</li>
            </ul> */}
          </div>
        </div>
        <br/>

        <div
                  className=" row Filters "
          style={{
            marginRight: "0px",
            marginLeft: "0px",
            padding: "0px 30px",
            zIndex: "89",
            marginTop:"-10px"


        }}
        >
          <div
            className="col-sm-2"
            style={{ marginTop: "-19px", zIndex: "99" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              State 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                handleSelectChange(e);
              }}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect(e);
                console.log(e, "jjk9090");
              }}
              value={multiselect}
              labelledBy="Select"
              // placeholder={"Search"}
            />
          </div>

          <div className="col-sm-2" style={{ marginTop: "-19px" }}>
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Region 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
                       isClearable={
  multiselect1
    ? Array.isArray(multiselect1)
      ? multiselect1.some(
          (item) => item.label === "ALL" || item.label === "All"
        )
        ? false
        : true
      : multiselect1.label === "ALL" || multiselect1.label === "All"
      ? false
      : true
    : true
}

              onremoved={(e) => {
                setMuliselect1(e);
              }}
              value={multiselect1}
              onInputChange={handleInputRegion}
              // placeholder={
              //   datas.state == ""
              //     ? "without selected state you can't select Region"
              //     : "search"
              // }
            />
          </div>

          <div className="col-sm-2" style={{ marginTop: "-19px" }}>
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Zone 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                handleZone(e);
              }}
              value={multiselect3}
              options={nameList5}
              isClearable={
  multiselect3
    ? Array.isArray(multiselect3)
      ? multiselect3.some(
          (item) => item.label === "ALL" || item.label === "All"
        )
        ? false
        : true
      : multiselect3.label === "ALL" || multiselect3.label === "All"
      ? false
      : true
    : true
}

              onremoved={(e) => {
                setMuliselect3(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              onInputChange={handleInputZone}
            />
          </div>


               <div
            className="col-sm-2"
            style={{ zIndex: "20", marginTop: "-19px" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Organization
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onChange={(e) => {
                  handlOrganizationList(e);            
              }}
              options={Organization_options}
              labelledBy="Select"
              onInputChange={handleInputOrganization}
              isClearable={
  state.DashboardOnboardOverviewCall.onboardashboardOnboardOverViewOrganizationList
    ? Array.isArray(state.DashboardOnboardOverviewCall.onboardashboardOnboardOverViewOrganizationList)
      ? state.DashboardOnboardOverviewCall.onboardashboardOnboardOverViewOrganizationList.some(
          (item) => item.label === "ALL" || item.label === "All"
        )
        ? false
        : true
      : state.DashboardOnboardOverviewCall.onboardashboardOnboardOverViewOrganizationList.label === "ALL" || state.DashboardOnboardOverviewCall.onboardashboardOnboardOverViewOrganizationList.label === "All"
      ? false
      : true
    : true
}
               value={state.DashboardOnboardOverviewCall.onboardashboardOnboardOverViewOrganizationList}
            />
          </div>

          <div
            className="col-sm-2"
            style={{ zIndex: "20", marginTop: "-19px" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Client 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onChange={(e) => {
                HandleClientBranches(e);
              }}
              filterOption={() => true}
              options={nameList4}
              labelledBy="Select"
              onInputChange={HandleInputBranch}
              // isMulti
             isClearable={
  state.DashboardOnboardOverviewCall.DashboardOnboardOverviewCLientList
    ? Array.isArray(state.DashboardOnboardOverviewCall.DashboardOnboardOverviewCLientList)
      ? state.DashboardOnboardOverviewCall.DashboardOnboardOverviewCLientList.some(
          (item) => item.label === "ALL" || item.label === "All"
        )
        ? false
        : true
      : state.DashboardOnboardOverviewCall.DashboardOnboardOverviewCLientList.label === "ALL" || state.DashboardOnboardOverviewCall.DashboardOnboardOverviewCLientList.label === "All"
      ? false
      : true
    : true
}
              value={state.DashboardOnboardOverviewCall.DashboardOnboardOverviewCLientList}
            />
          </div>

          <div
            className="col-sm-2 SelectedDate"
          
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px", width: "100%" }}
            >
              Select Date
              <span style={{ color: "red" }}>*</span>

            </label>
            <div className="datepicker_dash">
              <DateRangePicker

   onOpen={() => {
            
    setTimeout(() => {
      alignDateRangePicker(dateRangeRef.current);
    }, 80);
  }}
                                ref={dateRangeRef}

                     editable={false}   // ✅ FULLY disables typing & arrow keys

  style={{
    width: "100%",
    padding: "0px 5px",
  }}


                defaultValue={

              
                  state.EmployeeVerificationsNeed.ONboardFROMDATE == ""?
  
  
                  [
                    // new Date(new Date().setDate(today.getDate() - 30)),
                    // new Date(),
                    // new Date(),
                                                               new Date(range[0]), new Date(range[1])  
                  ]
  
                  :
                  [
                    
                     
                    new Date(state.EmployeeVerificationsNeed.ONboardFROMDATE),
                    new Date(state.EmployeeVerificationsNeed.ONboardTODATE)
                  ]
                
                }
                // defaultValue={

              
                //   state.EmployeeVerificationsNeed.FROMDATE ==""?
  
  
                //   [
                //     // new Date(new Date().setDate(today.getDate() - 30)),
                //     new Date(),
                //     new Date(),
                     
                //     // new Date(state.EmployeeVerificationsNeed.FROMDATE),
                //     // new Date(state.EmployeeVerificationsNeed.TODATE),
                //   ]
  
                //   :
                //   [
                //     // new Date(new Date().setDate(today.getDate() - 30)),
                //     // new Date(),
                //     // new Date(),
                     
                //     new Date(state.EmployeeVerificationsNeed.FROMDATE),
                //     new Date(state.EmployeeVerificationsNeed.TODATE),
                //   ]
                
                // }

                disabledDate={(date) => isAfter(date, new Date())}
                appearance="default"
                placement="bottomEnd"
                size="lg"
                ranges={predefinedBottomRanges}
                placeholder="From - To"
                // style={{ width: 270, padding: 10 }}
                onClean={(e) => cleaningrange(e)}
                onChange={(e) => {
                  if (e != null) {
                    setrange([]);
                    // setdoctorcount(0);
                    // setpatientcount(0);
                    // setappoinmentcount(0);
                    e.forEach((newValue) => {
                      var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                      var localISOTime = new Date(newValue - tzoffset)
                        .toISOString()
                        .slice(0, -1);
                      // "validtill",
                      handlechangedate(localISOTime);
                    });
                  }

                  // if (e != null && e.length === 2) {
                  //   const [startDate, endDate] = e;
                  //   const diffDays = differenceInDays(endDate, startDate);
                  //   if (diffDays === 30) {
                  //     // Since we are using inclusive range, difference should be 30 for 31 days
                  //     setrange([]);
                  //     e.forEach((newValue) => {
                  //       const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                  //       const localISOTime = new Date(newValue - tzoffset)
                  //         .toISOString()
                  //         .slice(0, -1);
                  //       handlechangedate(localISOTime);
                  //     });
                  //   } else if (diffDays < 30) {
                  //     setrange([]);
                  //     e.forEach((newValue) => {
                  //       const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                  //       const localISOTime = new Date(newValue - tzoffset)
                  //         .toISOString()
                  //         .slice(0, -1);
                  //       handlechangedate(localISOTime);
                  //     });
                  //   } else {
                  //     toast.error("Please select a range of exactly 31 days.", {
                  //       position: toast.POSITION.TOP_RIGHT,
                  //     });
                  //   }
                  // }
                }}
              />
            </div>
          </div>
          {/* {!RmStatus || !payrolStatus || !FindZero ? (
            <div className="col-sm-2" style={{ marginTop: "6px" }}>
              <button
                align="center"
                type="button"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  background: "transparent",
                }}
                onClick={(e) => {
                  HandleClick(e, "0");
                }}
              >
                <a class="dnbtn"></a>
              </button>
            </div>
          ) : null} */}
        </div>
        <br/>
        <div className="row DashRows">
          <div className="col-12 HeadingOnboard">
            <h3>Onboarding Details</h3>
          </div>

          <div className="col-6">
            <div className="row DashRows DashboardOverview" style={{ gap: "45px" }}>
              <div
                className="col-sm-4"
                // className="col-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  // border: "3px solid red",
                  flexDirection: "column",
                }}
                onClick={HandleAllEmployees}
              >
                <div
                  className="card Dashboard01"
                  // style={{
                  //   borderRadius: "7px",
                  //   height: "80px",
                  //   border: "none",

                  //   // width: "111%",
                  //   // boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                  //   boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                  // }}
                >
                  <div
                    className="card-Body DashboardCardBody"
                    // style={{
                    //   // padding: "8px",
                    //   display: "flex",
                    //   alignItems: "center",
                    //   justifyContent: "center",
                    //   flexDirection: "column",
                    //   background: "white",
                    //   border: "none",
                    //   borderRadius: "7px",
                    // }}
                  >
                    {/* <div
                      className="Dash"
                      style={{
                        // width: "100%",
                        justifyContent: "start",
                        gap: "35px",
                        alignItems: "center",
                        margin: "6px",
                        // padding: "0px 17px",
                      }}
                    > */}
                      <div
                        className="DashICON iconsEmpVer"
                        style={{ background: "#234492" }}
                      >
                        <img
                          src={EmployeeIcons}
                          style={{ width: "100%", height: "100%" }}
                        />
                      </div>

                      <div
                        className="Counts"
                        style={{
                          fontSize: "30px",
                          display: "flex",
                          flexDirection: "column",
                          marginLeft:"84px",
                          position:"absolute"

                        }}
                      >
                        <span
                          style={{
                            fontSize: "30px",
                            fontWeight: "900",
                          }}
                          className="DashboardCardHeader"
                        >
                          {/* {count} */}
                          {Perecentagedata.EmployeeCounts}
                        </span>

                        <span
                          style={{ fontSize: "16px", width: "94px" }}
                          className="DashboardCardHeader"
                        >
                          Total Count
                        </span>
                      </div>
                    {/* </div> */}
                  </div>
                </div>
              </div>

              <div
                className="col-sm-4"
                // className="col-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  // border: "3px solid red",
                  flexDirection: "column",
                }}
              >
                <div
                  className="card Dashboard01"
                  // style={{
                  //   borderRadius: "7px",
                  //   height: "80px",
                  //   border: "none",

                  //   // width: "100%",
                  //   // width: "111%",

                  //   // boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                  //   boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                  // }}
                >
                  <div
                    className="card-Body DashboardCardBody"
                    // style={{
                    //   // padding: "8px",
                    //   display: "flex",
                    //   alignItems: "center",
                    //   justifyContent: "center",
                    //   flexDirection: "column",
                    //   background: "white",
                    //   border: "none",
                    //   borderRadius: "7px",
                    // }}
                    onClick={HandleVerifiedemployees}
                  >
                    {/* <div
                      className="Dash"
                      style={{
                        // width: "100%",
                        justifyContent: "start",
                        gap: "35px",
                        alignItems: "center",
                        margin: "6px",
                        // padding: "0px 17px",
                      }}
                    > */}
                      <div
                        className="DashICON iconsEmpVer"
                        style={{ background: "#234492" }}
                      >
                        <img
                          src={ApproveIcon}
                          style={{ width: "100%", height: "100%" }}
                        />
                      </div>

                      <div
                        className="Counts"
                        style={{
                          fontSize: "30px",
                          display: "flex",
                          flexDirection: "column",
                          marginLeft:"84px",
                          position:"absolute"

                        }}
                      >
                        <span
                          style={{
                            fontSize: "30px",
                            fontWeight: "900",
                          }}
                          className="DashboardCardHeader"
                        >
                          {" "}
                          {/* {EployeeVerifiy} */}
                          {Perecentagedata.VerifiedEmpCount}
                        </span>

                        {/* {`${employeVerify}%`} */}

                        <span
                          style={{ fontSize: "16px" }}
                          className="DashboardCardHeader"
                        >
                          {" "}
                          Completed{" "}
                        </span>
                      </div>
                    </div>
                  {/* </div> */}
                </div>
                {/* 
                <div
                  class="Dash-info"
                  style={{ color: "black", textAlign: "center" }}
                >
                  <span class="text-muted"  style={{fontSize:"13px"}}>Onboarding Verified Employees </span>
                </div> */}
              </div>

              {/* ----------------------Pending----EMployees---------------- */}
              <div
                className="col-sm-4 "
                // className="col-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <div
                  className="card Dashboard01"
                  // style={{
                  //   borderRadius: "7px",
                  //   height: "80px",
                  //   border: "none",

                  //   // width: "100%",
                  //   // width: "111%",

                  //   // boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                  //   boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                  // }}
                >
                  <div
                    className="card-Body DashboardCardBody"
                    // style={{
                    //   display: "flex",
                    //   alignItems: "center",
                    //   justifyContent: "center",
                    //   flexDirection: "column",
                    //   background: "white",
                    //   border: "none",
                    //   borderRadius: "7px",
                    // }}
                    onClick={HandlePendngEmployess}
                  >
                    {/* <div
                      className="Dash"
                      style={{
                        // width: "100%",
                        justifyContent: "start",
                        // gap: "35px",
                        gap: "54px",
                        alignItems: "center",
                        margin: "6px",
                        // padding: "0px 17px",
                      }}
                    > */}
                      <div
                        className="DashICON iconsEmpVer"
                        style={{ background: "#234492" }}
                      >
                        <img
                          src={PendignIcons}
                          style={{ width: "100%", height: "100%" }}
                        />
                      </div>

                      <div
                        className="Counts"
                        style={{
                          fontSize: "30px",
                          display: "flex",
                          flexDirection: "column",
                          marginLeft:"84px",
                          position:"absolute"

                        }}
                      >
                        <span
                          style={{
                            fontSize: "30px",
                            fontWeight: "900",
                          }}
                          className="DashboardCardHeader"
                        >
                          {" "}
                          {/* {pendingCounts} */}
                          {/* {Perecentagedata.PayRequestCount} */}
                          {Perecentagedata.PendingEmployeCount}
                        </span>

                        <span
                          style={{ fontSize: "16px" }}
                          className="DashboardCardHeader"
                        >
                          Pending
                        </span>
                      </div>
                    </div>
                  {/* </div> */}
                </div>

                {/* <div
                  class="Dash-info"
                  style={{ color: "black", textAlign: "center" }}
                >
                  <h6 class="text-muted"> Pending Employees </h6>
                </div> */}
              </div>

              {/* ----------------------Pending----EMployees---------------- */}
              {/* <div
                className="col-sm-4 col-sm-4 col-xl-4"
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <div
                  className="card Dashboard01"
                  style={{
                    borderRadius: "7px",
                    height: "80px",
                    border: "none",
                    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                  }}
                >
                  <div
                    className="card-Body"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                      background: "white",
                      border: "none",
                      borderRadius: "7px",
                    }}
                    onClick={HandlePendngEmployess}
                  >
                    <div
                      className="Dash"
                      style={{
                        justifyContent: "start",
                        gap: "52px",

                        alignItems: "center",
                        margin: "6px",
                      }}
                    >
                      <div
                        className="DashICON iconsEmpVer"
                        style={{ background: "#234492" }}
                      >
                        <img
                          src={PendignIcons}
                          style={{ width: "100%", height: "100%" }}
                        />
                      </div>

                      
                      <div
                        className="Counts"
                        style={{
                          fontSize: "30px",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "30px",
                            fontWeight: "900",
                          }}
                          className="DashboardCardHeader"
                        >
                          {" "}
                          {KYCPending}
                        </span>

                        <span
                          style={{ fontSize: "12px" }}
                          className="DashboardCardHeader"
                        >
                          Kyc Pending
                        </span>
                      </div>


                    </div>
                  </div>
                </div>

         
              </div> */}

              {/* ----------------------Kyc Decline----EMployees---------------- */}
              <div
                className="col-sm-4 "
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <div
                  className="card Dashboard01"
                  // style={{
                  //   borderRadius: "7px",
                  //   height: "80px",
                  //   border: "none",
                  //   boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                  // }}
                >
                  {/* <div
                    className="card-Body"
                    style={{
                      padding: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                    onClick={HandledecineEmp}
                  >
                    <div className="Dash">
                      <div className="Counts" style={{ fontSize: "30px" }}>
                        {DeclineCounts}
                      </div>
                    </div>
                  </div> */}

                  <div
                    className="card-Body DashboardCardBody"
                    // style={{
                    //   // padding: "8px",
                    //   display: "flex",
                    //   alignItems: "center",
                    //   justifyContent: "center",
                    //   flexDirection: "column",
                    //   background: "white",
                    //   border: "none",
                    //   borderRadius: "7px",
                    // }}
                    onClick={HandledecineEmp}
                  >
                    {/* <div
                      className="Dash"
                      style={{
                        // width: "100%",
                        justifyContent: "start",
                        // gap: "35px",
                        gap: "54px",

                        alignItems: "center",
                        margin: "6px",
                        // padding: "0px 17px",
                      }}
                    > */}
                      <div
                        className="DashICON iconsEmpVer"
                        style={{ background: "#234492" }}
                      >
                        <img
                          src={DeclineIcon}
                          style={{ width: "100%", height: "100%" }}
                        />
                      </div>

                      <div
                        className="Counts"
                        // style={{
                        //   fontSize: "30px",
                        //   display: "flex",
                        //   flexDirection: "column",
                        // }}
                        style={{
                          fontSize: "30px",
                          display: "flex",
                          flexDirection: "column",
                          marginLeft:"84px",
                          position:"absolute"

                        }}
                      >
                        <span
                          style={{
                            fontSize: "30px",
                            fontWeight: "900",
                          }}
                          className="DashboardCardHeader"
                        >
                          {" "}
                          {/* {DeclineCounts} */}
                          {Perecentagedata.DeclineEmpCount}
                        </span>

                        {/* {`${employeVerify}%`} */}

                        <span
                          style={{ fontSize: "16px" }}
                          className="DashboardCardHeader"
                        >
                          Decline{" "}
                        </span>
                      </div>
                    {/* </div> */}
                  </div>
                </div>

                {/* <div
                  class="Dash-info"
                  style={{ color: "black", textAlign: "center" }}
                >
                  <h6 class="text-muted"> Declined Employees </h6>
                </div> */}
              </div>
            </div>
          </div>

          <div className="col-4">
            {/* <div className="col-4"> */}
              {!FindZero
              
              &&
              range.length > 0 && !range.includes("NaN-aN-aN")
              ? (
                // &&
                // Object.keys(state.DashboardOnboardOverviewCall.onboardingOverviewdata).length != 0

                <div class="card">
                  <Chart
                    chartType="PieChart"
                    data={pie_chart_data_Dia}
                    options={options_dia}
                    width={"400px"}
                    height={"290px"}
                  />
                </div>
              ) : (
                <div className="col-4">
                  <div
                    class="card"
                    style={{
                      display: "flex",
                      alignItems: "left",
                      justifyContent: "left",
                      height: "299px",
                      width: "425px",
                    }}
                  >
                    <div className="card-body DashboardCHART">
                      <h3
                        style={{ fontWeight: "900"}}
                        className="DashboardCardHeader"
                      >
                        Onboarding
                      </h3>
                      <p className="DashboardCardHeader Nodatas">
                        {" "}
                        No data available
                      </p>{" "}
                    </div>
                  </div>
                </div>
              )}
            {/* </div> */}
          </div>

     
       
          <div className="col-12 HeadingOnboard">
            <h3>RM Details</h3>
          </div>

          <div class="col-6">
            <div className="row DashRows DashboardOverview" style={{ gap: "45px" }}>
              {/* ----------------------Kyc Decline----EMployees---------------- */}
              <div
                className="col-sm-4"
                // className="col-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <div
                  // className="card"
                  // style={{
                  //   borderRadius: "7px",
                  //   height: "88px",
                  //   width: "50%",
                  //   // boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                  //   boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                  // }}

                  className="card Dashboard01"

                >
               
                  <div
                    className="card-Body DashboardCardBody"
                    
                    onClick={HandleAllEmployeesRM}
                  >
                    {/* <div
                      className="Dash"
                      style={{
                        // width: "100%",
                        justifyContent: "start",
                        gap: "35px",
                        // gap: "45px",

                        alignItems: "center",
                        margin: "6px",
                        // padding: "0px 17px",
                      }}
                    > */}
                      <div
                        className="DashICON iconsEmpVer"
                        style={{ background: "#234492" }}
                      >
                        <img
                          src={EmployeeIcons}
                          style={{ width: "100%", height: "100%" }}
                        />
                      </div>

                      <div
                        className="Counts"
                        style={{
                          fontSize: "30px",
                          display: "flex",
                          flexDirection: "column",
                          marginLeft:"84px",
                          position:"absolute"

                        }}
                      >
                        <span
                          style={{
                            fontSize: "30px",
                            fontWeight: "900",
                          }}
                          className="DashboardCardHeader"
                        >
                          {" "}
                          {Perecentagedata.RMRequestCount}
                        </span>


                        <span
                          style={{ fontSize: "16px" }}
                          className="DashboardCardHeader"
                        >
                          Request
                        </span>
                      </div>
                    {/* </div> */}
                  </div>
                </div>
              </div>

              {/* ----------------------Kyc Decline----EMployees---------------- */}
              <div
                className="col-sm-4 "
                // className="col-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <div

                  className="card Dashboard01"

                >
            

                  <div
                    className="card-Body DashboardCardBody"

                    onClick={HandleVerifiedemployeesRM}
                  >
                  
                      <div
                        className="DashICON iconsEmpVer"
                        style={{ background: "#234492" }}
                      >
                        <img
                          src={ApproveIcon}
                          style={{ width: "100%", height: "100%" }}
                        />
                      </div>

                      <div
                        className="Counts"
                        style={{
                          fontSize: "30px",
                          display: "flex",
                          flexDirection: "column",
                          marginLeft:"84px",
                          position:"absolute"

                        }}
                      >
                        <span
                          style={{
                            fontSize: "30px",
                            fontWeight: "900",
                          }}
                          className="DashboardCardHeader"
                        >
                          {" "}
                          {Perecentagedata.VerifiedRMEmp}
                        </span>

                        {/* {`${employeVerify}%`} */}

                        <span
                          style={{ fontSize: "16px" }}
                          className="DashboardCardHeader"
                        >
                          Completed{" "}
                        </span>
                      </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-4 "
                // className="col-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <div
                  // className="card"
                  // style={{
                  //   borderRadius: "7px",
                  //   height: "88px",
                  //   width: "50%",
                  //   // boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                  //   boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                  // }}

                  className="card Dashboard01"

                >


                  <div
                    className="card-Body DashboardCardBody"

                    onClick={HandlePendngRMEmployess}
                  >

                      <div
                        className="DashICON iconsEmpVer"
                        style={{ background: "#234492" }}
                      >
                        <img
                          src={PendignIcons}
                          style={{ width: "100%", height: "100%" }}
                        />
                      </div>

                      <div
                        className="Counts"
                        style={{
                          fontSize: "30px",
                          display: "flex",
                          flexDirection: "column",
                          marginLeft:"84px",
                          position:"absolute"

                        }}
                      >
                        <span
                          style={{
                            fontSize: "30px",
                            fontWeight: "900",
                          }}
                          className="DashboardCardHeader"
                        >
                          {" "}
                          {Perecentagedata.PendingRMEmploye}
                        </span>

                        {/* {`${employeVerify}%`} */}

                        <span
                          style={{ fontSize: "16px" }}
                          className="DashboardCardHeader"
                        >
                          Pending{" "}
                        </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* ----------------------Kyc Decline----EMployees---------------- */}
              <div
                // className="col-xl-4 col-sm-6 col-12"
                className="col-sm-4 "
                // className="col-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <div
               
                  className="card Dashboard01"
                
                >
               
                  <div
                    className="card-Body DashboardCardBody"

                    onClick={HandledecineEmpPayrRM}
                  >
                    {/* <div
                      className="Dash"
                      style={{
                        // width: "100%",
                        justifyContent: "start",
                        // gap: "35px",
                        gap: "45px",

                        alignItems: "center",
                        margin: "6px",
                        // padding: "0px 17px",
                      }}
                    > */}
                      <div
                        className="DashICON iconsEmpVer"
                        style={{ background: "#234492" }}
                      >
                        <img
                          src={DeclineIcon}
                          style={{ width: "100%", height: "100%" }}
                        />
                      </div>

                      <div
                        className="Counts"
                        style={{
                          fontSize: "30px",
                          display: "flex",
                          flexDirection: "column",
                          marginLeft:"84px",
                          position:"absolute"

                        }}
                      >
                        <span
                          style={{
                            fontSize: "30px",
                            fontWeight: "900",
                          }}
                          className="DashboardCardHeader"
                        >
                          {Perecentagedata.DeclineRMEmp}
                        </span>

                        {/* {`${employeVerify}%`} */}

                        <span
                          style={{ fontSize: "16px" }}
                          className="DashboardCardHeader"
                        >
                          Decline
                        </span>
                      {/* </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-4">
              {!RmStatus 
              &&
              range.length > 0 && !range.includes("NaN-aN-aN")

              ? (
                // Object.keys(state.DashboardOnboardOverviewCall.onboardingOverviewdata).length != 0

                <div class="card">
                  <Chart
                    chartType="PieChart"
                    data={DatasRM}
                    options={options_Rmdatas}
                    width={"400px"}
                    height={"290px"}
                    className="DashboardCardHeader"
                  />
                </div>
              ) : (
                <div className="col-4">
                  <div
                    class="card"
                    style={{
                      display: "flex",
                      alignItems: "left",
                      justifyContent: "left",
                      height: "299px",
                      width: "425px",
                    }}
                  >
                    <div className="card-body DashboardCHART">
                      <h3
                        style={{ fontWeight: "900" ,fontSize:"14px" }}
                        className="DashboardCardHeader"
                      >
                        RM Details
                      </h3>
                      <p className="DashboardCardHeader Nodatas">
                        {" "}
                        No data available
                      </p>{" "}
                    </div>
                  </div>
                </div>
              )}
          </div>
        </div>
      </div>
    </>
  );
};

export default OnboardingDash;
